import { performUndoableAction } from 'components/Graph/commands/history/performUndoableAction';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { clearSharedView } from '../helpers/clearSharedView';

export const showAllNodes: GraphCommandFactory =
  (cmdContext, dispatch) => () => {
    cmdContext.updateState(clearSharedView);
    const prevHiddenNodes = cmdContext.getState().graph.hiddenNodes;
    dispatch(performUndoableAction, {
      undo: () => {
        cmdContext.updateState((draft) => {
          draft.graph.hiddenNodes = prevHiddenNodes;
        });
      },
      redo: () => {
        cmdContext.updateState((draft) => {
          draft.graph.hiddenNodes.clear();
        });
      },
    });
  };
